
// Define the complete list of symptoms
export const SYMPTOMS = [
  { id: 'hot-flashes', label: 'Experience hot flashes or night sweats' },
  { id: 'fatigue', label: 'Feel unusually tired without exertion' },
  { id: 'mood-changes', label: 'Mood changes rapidly (e.g., from happy to sad)' },
  { id: 'insomnia', label: 'Difficulty sleeping through the night' },
  { id: 'breast-tenderness', label: 'Notice swelling or tenderness in breasts' },
  { id: 'weight-gain', label: 'Experiencing unexplained weight gain' },
  { id: 'low-libido', label: 'Decreased interest in sexual activity' },
  { id: 'hair-changes', label: 'Hair thinning or becoming dryer' },
  { id: 'concentration', label: 'Trouble concentrating or experiencing memory lapses' },
  { id: 'anxiety', label: 'Experience anxiety or feelings of being overwhelmed' },
  { id: 'dry-skin', label: 'Skin is drier or more brittle than usual' },
  { id: 'muscle-loss', label: 'Observed decrease in muscle mass or strength' },
  { id: 'menstrual-changes', label: 'Irregular or heavy menstrual cycles' },
  { id: 'bloating', label: 'Feel bloated or experience digestive issues' },
  { id: 'recovery', label: 'Find it hard to recover from stress or illness' },
  { id: 'wired-tired', label: 'Feel wired yet tired, especially in the evening' },
  { id: 'food-cravings', label: 'Experience cravings for salty or sweet foods' },
  { id: 'morning-fatigue', label: 'Have a high level of fatigue each morning, regardless of sleep' },
  { id: 'dry-eyes', label: 'Dryness of the eyes' }
];

// Define steps for the assessment process
export const ASSESSMENT_STEPS = [
  "Personal Information",
  "Goals & Concerns",
  "Medical History",
  "Sleep Assessment",
  "Symptom Assessment",
  "Summary"
];
